import type { TabsConfig } from "app/pages/sales-intelligence/modules/leads-search/types";
import { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";

import FindAppsAndroidTabContainer from "../containers/FindAppsAndroidTabContainer";
import FindAppsAndroidTabContentContainer from "../containers/FindAppsAndroidTabContentContainer";
import FindAppsIosTabContainer from "../containers/FindAppsIosTabContainer";
import FindAppsIosTabContentContainer from "../containers/FindAppsIosTabContentContainer";

export const tabsConfig: TabsConfig<AppsSourceType> = [
    {
        id: AppsSourceType.GoogleStore,
        title: { key: "si.find_apps.tab.title.googleStore" },
        iconNameActive: "google-play-colored",
        iconNameInactive: "google-play-grey",
        tabComponent: FindAppsAndroidTabContainer,
        panelComponent: FindAppsAndroidTabContentContainer,
    },
    {
        id: AppsSourceType.AppleStore,
        title: { key: "si.find_apps.tab.title.appleStore" },
        iconNameActive: "apple-store-colored",
        iconNameInactive: "apple-store-grey",
        tabComponent: FindAppsIosTabContainer,
        panelComponent: FindAppsIosTabContentContainer,
    },
];
